// components/filtv/filtvDemoData.js
//
// Local fallback data. Used automatically by useFiltvData() whenever the
// real API isn't available yet. Channels 103, 104, 105, 107, 108, 110 are
// deliberately left without ads so you can see the "off air" state in action.

export const channels = [
    { lcn: 100, emoji: "💄", title: "Fashion" },
    { lcn: 101, emoji: "👗", title: "Women Boutique" },
    { lcn: 102, emoji: "👠", title: "Footwear" },
    { lcn: 103, emoji: "💍", title: "Jewellery" },
    { lcn: 104, emoji: "👜", title: "Bags" },
    { lcn: 105, emoji: "💅", title: "Beauty" },
    { lcn: 106, emoji: "📱", title: "Electronics" },
    { lcn: 107, emoji: "🏡", title: "Home Decor" },
    { lcn: 108, emoji: "🍳", title: "Kitchen" },
    { lcn: 109, emoji: "🎁", title: "Gift Store" },
    { lcn: 110, emoji: "🛒", title: "Grocery" },
];

export const advertisements = [
    {
        advertisementCode: "AD-FASH100-01",
        cartProductCode: "6a55ec2a4855100c3a8bc062",
        lcn: 100,
        merchant: "XYZ Boutique",
        area: "Dombivli",
        city: "Mumbai",
        state: "Maharashtra",
        pincode: "421202",
        videoType: "youtube",
        videoLink: "https://www.youtube.com/embed/RlpPKlgHAjs?autoplay=1&mute=1&rel=0",
        offer: "Flat 40% OFF",
        offerEndsInMinutes: 180,
        phone: "+919999999999",
        whatsapp: "+919999999999",
    },
    {
        advertisementCode: "AD-FASH100-02",
        cartProductCode: "CPC-FASH100-02",
        lcn: 100,
        merchant: "ABC Fashion",
        area: "Palava",
        city: "Mumbai",
        state: "Maharashtra",
        pincode: "421204",
        videoType: "youtube",
        videoLink: "https://www.youtube.com/embed/RlpPKlgHAjs?autoplay=1&mute=1&rel=0",
        offer: "Buy 2 Get 1 Free",
        offerEndsInMinutes: 240,
        phone: "+919888888888",
        whatsapp: "+919888888888",
    },
    {
        advertisementCode: "AD-BOUT101-01",
        cartProductCode: "6a55ec2a4855100c3a8bc062",
        lcn: 101,
        merchant: "Fashion Queen",
        area: "Manpada",
        city: "Thane",
        state: "Maharashtra",
        pincode: "400610",
        videoType: "youtube",
        videoLink: "https://www.youtube.com/embed/RlpPKlgHAjs?autoplay=1&mute=1&rel=0",
        offer: "Flat ₹500 Off",
        offerEndsInMinutes: 90,
        phone: "+919777777777",
        whatsapp: "+919777777777",
    },
    {
        advertisementCode: "AD-FOOT102-01",
        cartProductCode: "CPC-FOOT102-01",
        lcn: 102,
        merchant: "StepUp Footwear",
        area: "Andheri",
        city: "Mumbai",
        state: "Maharashtra",
        pincode: "400053",
        videoType: "youtube",
        videoLink: "https://www.youtube.com/embed/RlpPKlgHAjs?autoplay=1&mute=1&rel=0",
        offer: "Flat 25% OFF",
        offerEndsInMinutes: 300,
        phone: "+919666666666",
        whatsapp: "+919666666666",
    },
    {
        advertisementCode: "AD-ELE106-01",
        cartProductCode: "CPC-ELE106-01",
        lcn: 106,
        merchant: "GadgetHub",
        area: "Powai",
        city: "Mumbai",
        state: "Maharashtra",
        pincode: "400076",
        videoType: "youtube",
        videoLink: "https://www.youtube.com/embed/RlpPKlgHAjs?autoplay=1&mute=1&rel=0",
        offer: "Up to ₹2,000 Off",
        offerEndsInMinutes: 120,
        phone: "+919555555555",
        whatsapp: "+919555555555",
    },
    {
        advertisementCode: "AD-GIFT109-01",
        cartProductCode: "CPC-GIFT109-01",
        lcn: 109,
        merchant: "Little Joys Gifting",
        area: "Bandra",
        city: "Mumbai",
        state: "Maharashtra",
        pincode: "400050",
        videoType: "youtube",
        videoLink: "https://www.youtube.com/embed/RlpPKlgHAjs?autoplay=1&mute=1&rel=0",
        offer: "Free Gift Wrap",
        offerEndsInMinutes: 200,
        phone: "+919444444444",
        whatsapp: "+919444444444",
    },
];
